<div class="video-controls">
  <button
    appButton
    name="DONTREPORT"
    location="video-viewer-controls"
    [iconButton]="true"
    color="simple-gray-50"
    height="0"
    shape="round"
    (mousedown)="mouseDown(-1)"
    (mouseup)="mouseUp()"
    (mouseout)="mouseUp()"
    [appTooltip]="'Previous frame'"
  >
    <app-svg src="/assets/icons/24/chevron-left.svg" size="0"></app-svg>
  </button>
  <button
    appButton
    name="mode-toggle"
    location="video-viewer-controls"
    color="simple-gray-50"
    height="0"
    spacing="1"
    shape="round"
    class="time-button"
    [appTooltip]="'Time Format'"
    (click)="toggleMode()"
  >
    <span class="played">
      @if (time) {
        @if (state.videoSettings.timeMode === 'seconds') {
          {{ time.currentSecond / 60 | floor | number: '2.0-0' }}:{{
            time.currentSecond % 60 | floor | number: '2.0-0'
          }}
        }
        @if (state.videoSettings.timeMode === 'frames') {
          {{ time.currentFrame | floor }}
        }
      }
      @if (!time) {
        00:00
      }
    </span>
    <span class="time-sep">/</span>
    <span>
      @if (time) {
        @if (state.videoSettings.timeMode === 'seconds') {
          {{ time.durationSeconds / 60 | floor | number: '2.0-0' }}:{{
            time.durationSeconds % 60 | floor | number: '2.0-0'
          }}
        }
        @if (state.videoSettings.timeMode === 'frames') {
          {{ time.durationFrames | floor }}
        }
      }
      @if (!time) {
        00:00
      }
    </span>
  </button>
  <button
    appButton
    name="DONTREPORT"
    location="video-viewer-controls"
    [iconButton]="true"
    color="simple-gray-50"
    height="0"
    shape="round"
    (mousedown)="mouseDown(1)"
    (mouseup)="mouseUp()"
    (mouseout)="mouseUp()"
    [appTooltip]="'Next frame'"
  >
    <app-svg src="/assets/icons/24/chevron-right.svg" size="0"></app-svg>
  </button>
</div>
